export enum VideoTypeEnum {
  VIDEO = 'video',
  READING = 'reading',
  WEBSITE_LINK = 'websiteLink',
  QUIZ = 'quizz',
  FILE_REPOSITORY = 'files',
  PDF = 'pdf',
}
